// extracted by mini-css-extract-plugin
export var divider = "_tu-0";
export var systemMessage = "_tu-1";